import { jsx as _jsx } from "react/jsx-runtime";
import { Check as CheckIcon } from "@air/next-icons";
import { memo } from "react";
export const SelectedOptionIcon = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsx(CheckIcon, {
        className: "size-4 text-blue-10"
    }));
SelectedOptionIcon.displayName = "SelectedOptionIcon";
